import dayjs from 'dayjs'
import sortBy from 'lodash/sortBy'
import uniq from 'lodash/uniq'
import CreativeValidation from './CreativeValidation'

const getWarningMessagesByCampaignBudget = campaignBudget => {
  const messages = []
  if (campaignBudget.noCreativesWarning) {
    messages.push(
      '・クリエイティブが設定されていない配信スケジュールがあります。',
    )
  }
  if (campaignBudget.isDateTimeMissing) {
    messages.push(
      '・スケジュールが設定されていない期間があるため、未配信となる期間があります。',
    )
  }
  const creativeWarningMessages = sortBy(
    uniq(
      campaignBudget.creativeSchedules
        .map(cs => CreativeValidation.getWarningMessages(cs.creatives))
        .filter(message => message)
        .flat(),
    ),
  )
  return messages.concat(creativeWarningMessages)
}

const getWarningMessagesByCreativeSchedule = creativeSchedule => {
  const messages = []
  if (creativeSchedule.noCreativesWarning) {
    messages.push('・クリエイティブが設定されてません。')
  }
  const creativeWarningMessages = CreativeValidation.getWarningMessages(
    creativeSchedule.creatives,
  )
  return messages.concat(creativeWarningMessages)
}

const getErrorMessages = (campaignBudget, creativeSchedule) => {
  const messages = []
  if (creativeSchedule) {
    if (!creativeSchedule.startTime && !creativeSchedule.endTime) return
    if (creativeSchedule.isStartTimeAfterEndTime) {
      messages.push(
        '・配信開始時刻が終了時刻より前になるように修正してください。',
      )
    }
    if (
      creativeSchedule.isNotInCampaignBudgetPeriod(
        campaignBudget.startTime,
        campaignBudget.endTime,
      )
    ) {
      messages.push(
        '・キャンペーン予算内に設定されてません。設定を変更してください。',
      )
    }
  } else {
    if (campaignBudget.isStartTimeAfterEndTime) {
      messages.push(
        '・配信開始時刻が終了時刻より前になってる配信スケジュールがあります。',
      )
    }
    if (campaignBudget.isNotInCampaignBudgetPeriod) {
      messages.push(
        '・キャンペーン予算内に設定されていない配信スケジュールがあります。',
      )
    }
  }
  if (getOverlappingIndicesList(campaignBudget).length > 0) {
    messages.push(
      '・配信スケジュールに期間の重複しています。配信スケジュールの設定を変更をしてください。',
    )
  }
  return messages
}

/**
 * 日付被りがあるスケジュールのindexリストを返却する.
 * @param campaignBudget
 * @returns {[]|*[]}
 */
const getOverlappingIndicesList = campaignBudget => {
  const overlappingIndicesList = []
  campaignBudget.creativeSchedules.map((creativeSchedule, index) => {
    return campaignBudget.creativeSchedules.map(
      (otherCreativeSchedule, otherIndex) => {
        const timeList = materializedTime(
          creativeSchedule,
          otherCreativeSchedule,
          campaignBudget,
        )
        if (
          index !== otherIndex &&
          dayjs(timeList.startTime).isBefore(timeList.otherEndTime) &&
          dayjs(timeList.otherStartTime).isBefore(timeList.endTime)
        ) {
          overlappingIndicesList.push(otherIndex)
        }
      },
    )
  })
  return overlappingIndicesList
}

const materializedTime = (cs, ocs, item) => {
  return {
    startTime: cs.startTime ? cs.startTime : item.startTime,
    endTime: cs.endTime ? cs.endTime : item.endTime,
    otherStartTime: ocs.startTime ? ocs.startTime : item.startTime,
    otherEndTime: ocs.endTime ? ocs.endTime : item.endTime,
  }
}

export default {
  getWarningMessagesByCampaignBudget,
  getWarningMessagesByCreativeSchedule,
  getErrorMessages,
}
